/**
 * Defined in:
 *   {@link file://./../../../dxos/halo/credentials.proto}
 */
export var MembershipPolicy;
(function (MembershipPolicy) {
    MembershipPolicy[MembershipPolicy["INVITE"] = 0] = "INVITE";
    MembershipPolicy[MembershipPolicy["LOCKED"] = 1] = "LOCKED";
})(MembershipPolicy || (MembershipPolicy = {}));
export var SpaceMember;
(function (SpaceMember) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/halo/credentials.proto}
     */
    let Role;
    (function (Role) {
        Role[Role["INVALID"] = 0] = "INVALID";
        Role[Role["ADMIN"] = 1] = "ADMIN";
        Role[Role["EDITOR"] = 2] = "EDITOR";
        Role[Role["READER"] = 3] = "READER";
        Role[Role["OWNER"] = 4] = "OWNER";
        Role[Role["REMOVED"] = 5] = "REMOVED";
    })(Role = SpaceMember.Role || (SpaceMember.Role = {}));
})(SpaceMember || (SpaceMember = {}));
export var AdmittedFeed;
(function (AdmittedFeed) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/halo/credentials.proto}
     */
    let Designation;
    (function (Designation) {
        Designation[Designation["GENERAL"] = 0] = "GENERAL";
        Designation[Designation["CONTROL"] = 1] = "CONTROL";
        Designation[Designation["DATA"] = 2] = "DATA";
    })(Designation = AdmittedFeed.Designation || (AdmittedFeed.Designation = {}));
})(AdmittedFeed || (AdmittedFeed = {}));
/**
 * Defined in:
 *   {@link file://./../../../dxos/halo/credentials.proto}
 */
export var DeviceType;
(function (DeviceType) {
    DeviceType[DeviceType["UNKNOWN"] = 0] = "UNKNOWN";
    DeviceType[DeviceType["BROWSER"] = 1] = "BROWSER";
    DeviceType[DeviceType["NATIVE"] = 2] = "NATIVE";
    DeviceType[DeviceType["AGENT"] = 3] = "AGENT";
    DeviceType[DeviceType["AGENT_MANAGED"] = 4] = "AGENT_MANAGED";
    DeviceType[DeviceType["MOBILE"] = 5] = "MOBILE";
})(DeviceType || (DeviceType = {}));
//# sourceMappingURL=credentials.js.map